import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import { STATUS_IDENTIFIERS } from "models";
import "modules/StatusListDashboard/components/StatusesList/StatusesList.scss";

import type { AppointmentStatus } from "models";

export type StatusListFormValues = {
  statuses: AppointmentStatus[];
};

const FormHelper = createFormHelper<StatusListFormValues>();

export const STATUS_LABELS: Partial<Record<STATUS_IDENTIFIERS, [string, string]>> = {
  [STATUS_IDENTIFIERS.CanceledStatus]: ["v8_canceled", "Canceled"],
  [STATUS_IDENTIFIERS.NewCarStatus]: ["v8_new_car", "New car"],
  [STATUS_IDENTIFIERS.CarCheckStatus]: ["v8_car_check", "Car Check"],
  [STATUS_IDENTIFIERS.PricingOKStatus]: ["v8_pricing_ok", "Pricing OK"],
  [STATUS_IDENTIFIERS.CustomerOKStatus]: ["v8_customer_ok", "Customer OK"],
  [STATUS_IDENTIFIERS.CarReadyStatus]: ["v8_car_ready", "Car ready"],
  [STATUS_IDENTIFIERS.DiagnoseStatus]: ["v8_diagnose", "Diagnose"],
  [STATUS_IDENTIFIERS.AannameOKStatus]: ["v8_initial_check_done", "Initial check done"],
  [STATUS_IDENTIFIERS.CalculatingStatus]: ["v8_calculating_price", "Calculating Price"],
  [STATUS_IDENTIFIERS.ContactStatus]: ["v8_customer_being_contacted", "Customer being contacted"],
  [STATUS_IDENTIFIERS.CarCheckStartedStatus]: ["v8_car_check_started", "Car check started"],
  [STATUS_IDENTIFIERS.QualityCheckStatus]: ["v8_quality_check_finished", "Quality check finished"],
  [STATUS_IDENTIFIERS.CustomerAnsweredStatus]: ["v8_customer_answered", "Customer answered"],
  [STATUS_IDENTIFIERS.BackOrder]: ["v8_backorder", "Backorder"],
  [STATUS_IDENTIFIERS.HandleCheckIn]: ["v8_check_in_to_be_done", "Check In to be done"],
  [STATUS_IDENTIFIERS.CheckInDone]: ["v8_checkin_done", "Checkin Done"],
  [STATUS_IDENTIFIERS.CarInShop]: ["v8_car_in_shop", "Car in shop"],
  [STATUS_IDENTIFIERS.CarOkPlusRepairOverivew]: ["v8_car_ready_repair_overview_sent", "Car ready repair overview sent"],
  [STATUS_IDENTIFIERS.QualityCheckPlusRepairOverview]: ["v8_quality_check_finished_repair_overview_sent", "Quality check finished repair overview sent"],
  [STATUS_IDENTIFIERS.CarOutOfShop]: ["v8_car_out_of_shop", "Car out of shop"]
};

export const StatusesList = () => {
  const { t } = useTranslation();

  const statuses = FormHelper.useWatch("statuses");
  const sortedStatuses = statuses.map((status, index) => ({ status, index })).sort((a, b) => a.status.ordering - b.status.ordering);

  const getDefaultStatusLabel = (identifier: STATUS_IDENTIFIERS) => {
    const label = STATUS_LABELS[identifier];
    return label ? t(...label) : `${identifier}`;
  };

  return (
    <Element name="statuses" className="StatusesList">
      <div className="section-title">
        <Icon className="thumbtack" />
        <span className="section-title-text">{t("v8_statuses", "Statuses")}</span>
      </div>

      <div className="StatusesList-grid">
        {sortedStatuses.map(({ status, index }) => (
          <Form.Field key={status.id}>
            <label>{getDefaultStatusLabel(status.identifier)}</label>
            <div className="status-name-input">
              <FormHelper.Field.ColorPicker name={`statuses.${index}.color`} formFieldProps={{ className: "status-color-field" }} />
              <FormHelper.Field.Input name={`statuses.${index}.name`} inputProps={{ placeholder: t("v8_name", "Name") }} />
            </div>
          </Form.Field>
        ))}
      </div>
    </Element>
  );
};
